<template>
  <div id="wiki-home">
    <v-card flat>
      <v-img
        :src="titleImg"
        max-height="200"
        aspect-ratio=1.5
        position="bottom 45% left"
        gradient="to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      />
    </v-card>

    <v-container fluid>
      <v-layout row wrap>

        <v-flex xs12 sm8 offset-sm2>
          <v-card color="grey darken-4">
            <v-container fluid>
            <v-layout column wrap>
              <v-flex>
              <v-tabs
                v-model="active"
                color="primary"
                dark
                slider-color="accent"
              >
                <v-tab ripple>Home</v-tab>
                <v-tab-item>
                  <wiki-home></wiki-home>
                </v-tab-item>
                <v-tab ripple>Tutorials</v-tab>
                <v-tab-item>
                  <wiki-tutorials></wiki-tutorials>
                </v-tab-item>
                <v-tab ripple>Setup</v-tab>
                <v-tab-item>
                  <wiki-setup></wiki-setup>
                </v-tab-item>
              </v-tabs>
              </v-flex>
            </v-layout>
            </v-container>
          </v-card>
        </v-flex>
                
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ExampleCard from '../../components/cards/ExampleCard'
import WikiStore from '../../stores/WikiStore'
import WikiTree from '../../components/trees/WikiTree'
import HomePage from './pages/Home'
import TutorialsPage from './pages/Tutorials'
import SetupPage from './pages/Setup'

export default {
  data () {
    return {
      titleImg: 'https://images.unsplash.com/photo-1521198807864-bc8cfc485949?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=d9072a30f8e32fcf095e888eab331bf2&auto=format&fit=crop&w=1267&q=80',
      active: null
    }
  },

  components: {
    'example-card': ExampleCard,
    'section-tree': WikiTree,
    'wiki-home': HomePage,
    'wiki-tutorials': TutorialsPage,
    'wiki-setup': SetupPage
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/wiki/Wiki.vue